/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetAssetOcppSettingsResponseDto
 */
export interface GetAssetOcppSettingsResponseDto {
    /**
     * 
     * @type {string}
     * @memberof GetAssetOcppSettingsResponseDto
     */
    organizationId: string;
    /**
     * Whether External CSMS proxy is enabled for the asset organization
     * @type {boolean}
     * @memberof GetAssetOcppSettingsResponseDto
     */
    externalCsmsEnabled: boolean;
    /**
     * Whether charger HTTP Basic Authentication is required (only when External CSMS proxy is enabled)
     * @type {boolean}
     * @memberof GetAssetOcppSettingsResponseDto
     */
    chargerAuthenticationEnabled: boolean;
}

/**
 * Check if a given object implements the GetAssetOcppSettingsResponseDto interface.
 */
export function instanceOfGetAssetOcppSettingsResponseDto(value: object): value is GetAssetOcppSettingsResponseDto {
    if (!('organizationId' in value) || value['organizationId'] === undefined) return false;
    if (!('externalCsmsEnabled' in value) || value['externalCsmsEnabled'] === undefined) return false;
    if (!('chargerAuthenticationEnabled' in value) || value['chargerAuthenticationEnabled'] === undefined) return false;
    return true;
}

export function GetAssetOcppSettingsResponseDtoFromJSON(json: any): GetAssetOcppSettingsResponseDto {
    return GetAssetOcppSettingsResponseDtoFromJSONTyped(json, false);
}

export function GetAssetOcppSettingsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAssetOcppSettingsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'organizationId': json['organizationId'],
        'externalCsmsEnabled': json['externalCsmsEnabled'],
        'chargerAuthenticationEnabled': json['chargerAuthenticationEnabled'],
    };
}

export function GetAssetOcppSettingsResponseDtoToJSON(json: any): GetAssetOcppSettingsResponseDto {
    return GetAssetOcppSettingsResponseDtoToJSONTyped(json, false);
}

export function GetAssetOcppSettingsResponseDtoToJSONTyped(value?: GetAssetOcppSettingsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'organizationId': value['organizationId'],
        'externalCsmsEnabled': value['externalCsmsEnabled'],
        'chargerAuthenticationEnabled': value['chargerAuthenticationEnabled'],
    };
}

